import React from "react";

export default function Eventos() {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Eventos Deportivos</h1>
      <p>Bienvenido a la sección de competencias y eventos deportivos de Ataca Perú.</p>

      <ul>
        <li>🏃‍♂️ Maratón Lima42K – Mayo 2026</li>
        <li>🚴‍♀️ Ciclismo en Cusco – Julio 2026</li>
        <li>🏊‍♂️ Triatlón Arequipa – Agosto 2026</li>
      </ul>
    </div>
  );
}
